/**
 * Layer CSVs from S3 are SI (Mg/ha). The dashboard audience is US-based,
 * so we convert at display time.
 *
 * 1 Mg = 1.10231 short tons, 1 ha = 2.47105 acres
 *   => 1 Mg/ha = 1.10231 / 2.47105 = 0.44609 short tons/acre
 */
export const MG_PER_HA_TO_TONS_PER_ACRE = 0.44609;

export const tonsPerAcre = (mgPerHa: number): number =>
  mgPerHa * MG_PER_HA_TO_TONS_PER_ACRE;

export const MG_TO_SHORT_TONS = 1.10231;

// Total mass conversion: Mg (metric tonnes) → US short tons. Pair with the
// "tons" labels used elsewhere in the dashboard (soil carbon, growth
// curves), which are short tons by the same convention.
export const shortTons = (mg: number): number => mg * MG_TO_SHORT_TONS;

export const HA_TO_ACRES = 2.47105;

export const hectaresToAcres = (ha: number): number => ha * HA_TO_ACRES;

export const M_TO_FT = 3.28084;

export const metersToFeet = (m: number): number => m * M_TO_FT;
